import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import styles from "./Banner.module.css";

export default function Banner() {
  const navigate = useNavigate();
  const { setAuthModal, userdata } = useAuth();
    
  const handleBecomeMember = () => {
    if (userdata) {
      // User is logged in, redirect to appropriate dashboard
      if (userdata.role === 'institution') {
        navigate('/dashboard/institution');
      } else {
        navigate(`/dashboard/${userdata.role}`);
      }
    } else {
      // User is not logged in, open signup popup
      setAuthModal({ open: true, tab: "signup" });
    }
  };
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent2}>Mentorship &</span>{" "}
            <span className={styles.accent}>Membership</span>
          </h1>
          <p>
            Connect with expert mentors, join our community of researchers, and
            advance your academic journey
          </p>
          <div className={styles.heroActions}>
            <button className={`${styles.button} ${styles.orange}`} onClick={() => navigate("/mentors")}>
              Find a Mentor
            </button>
            <button onClick={handleBecomeMember} className={styles.button}>Become a Member</button>
          </div>
        </div>
      </div>
    </section>
  );
}
